export default __webpack_public_path__ + "static/media/4.bd48fab9.png";